import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App.jsx';
import './lib/posthog.js';
import './index.css';

const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const isLocalDev = import.meta.env.DEV || isLocalHost;
const sentryIntegrations = [Sentry.browserTracingIntegration()];

if (!isLocalDev) {
  sentryIntegrations.push(Sentry.replayIntegration());
}

Sentry.init({
  dsn: "https://7e0836f9234ff54a373fca5160671893@o4511075596959744.ingest.us.sentry.io/4511076916985856",
  integrations: sentryIntegrations,
  // Tracing
  tracesSampleRate: isLocalDev ? 0.2 : 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/.*\.up\.railway\.app/],
  // Session Replay
  replaysSessionSampleRate: isLocalDev ? 0 : 0.1,
  replaysOnErrorSampleRate: isLocalDev ? 0 : 1.0,
  maxBreadcrumbs: 50,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
